import { useTranslation } from "react-i18next";
import clsx from "clsx";
import { styled, Tooltip } from "@mui/material";
import OpacitySlider from "./OpacitySlider";
import overlayToggle from "assets/icons/fieldPage/overlayToggle.svg";

const ToolsWrapper = styled("div")({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "8px",
  "& .toggle-overlay-button": {
    backgroundColor: "rgba(255, 255, 255, 0.667)",
    borderRadius: "12px",
    border: "2px solid rgba(0, 0, 0, 0.2)",
    width: "36px",
    height: "36px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "background-color 0.3s ease",
    backgroundClip: "padding-box",
    boxShadow: "none",
    "&.active": { backgroundColor: "rgba(255, 255, 255, 0.9)" },
    "&:hover": { backgroundColor: "rgba(255, 255, 255, 0.9)" },
  },
});

const MapPreviewTools = ({
  opacity,
  setOpacity,
  HasOverlay,
  toggleOverlay,
}) => {
  const { t } = useTranslation();

  return (
    <ToolsWrapper>
      <Tooltip
        title={t("SingleFieldPage.GroundConditions.Overlay")}
        placement="right"
        className={clsx("toggle-overlay-button", { active: HasOverlay })}
      >
        <img
          src={overlayToggle}
          alt={t("SingleFieldPage.GroundConditions.Overlay")}
          onClick={toggleOverlay}
        />
      </Tooltip>
      <OpacitySlider
        opacity={opacity}
        onChange={(object) => {
          setOpacity(object.target.value);
        }}
      />
    </ToolsWrapper>
  );
};

export default MapPreviewTools;
